import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { getIsConnected } from '@puzzlehq/sdk';
import { Route as IndexRoute } from './index.js';
import { LoadingMessage } from '@src/components/LoadingMessage.js';
import { getJigsawStatus } from '@puzzlehq/frontend-utils';
import { getTimeoutPromise } from '@src/data/utils.js';
import { ErrorMessage } from '@src/components/ErrorMessage.js';

export const Route = createFileRoute('/game')({
  beforeLoad: async () => {
    try {
      const isConnected = await getIsConnected();
      if (!isConnected) {
        throw redirect({ to: IndexRoute.to });
      }
    } catch (e) {
      console.error(e);
      throw redirect({ to: IndexRoute.to });
    }

    await Promise.race([
      getJigsawStatus(),
      getTimeoutPromise(15000, 'Error fetching game status.'),
    ]);
  },
  pendingComponent: () => <LoadingMessage message='Loading your squash' />,
  errorComponent: function Component({ error }) {
    return <ErrorMessage errorMessage={error.message} />;
  },
  component: function Component() {
    return <Outlet />;
  },
});
